"use strict";
/*
 *
 * Backoffice UI sends notifications requests to apiv2 with DTOs based on BaseNotificationDto.
 *
 * The NotificationCreateDto is used when communicating (from apiv2) to the NotificationsService.
 *
 *  - ProgramsSeasons controller has endpoints to send notifications to attendees using it's own subclass DTOs.
 *  - NotificationBlasts controller has endpoints to send notifications to recipients using segment-building query DTOs that subclass this.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseNotificationDto = void 0;
/* Common properties for all Notifications coming from UI */
class BaseNotificationDto {
}
exports.BaseNotificationDto = BaseNotificationDto;
//# sourceMappingURL=backoffice.notify.dto.js.map